import React from "react";
import Nav1 from "../component/nav1/Nav1";
import SidebarDrawer from "../component/SidebarDrawer";

import Users from "./Users";
import Analytics from "./Analytics";
import Packages from "./Packages";
import Accounts from "./Accounts";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { Box, Grid } from "@chakra-ui/react";
import KnowledgeBank from "./KnowledgeBank";
import Index from "../component/Index";

const Dashboard = () => {
  return (
    <Router>
      <Grid
        templateAreas="'sidebar navbar' 'sidebar body'"
        templateColumns="auto 1fr"
        templateRows="auto 1fr"
      >
        <Box sx={{ gridArea: "sidebar", minHeight: "100vh", bg: "#F6F7FB" }}>
          <SidebarDrawer />
        </Box>
        <Box sx={{ gridArea: "navbar" }}>
          <Nav1 />
        </Box>
        <Box sx={{ gridArea: "body" }}>
          <Switch>
            <Route path="/dashboard/index" component={Index} />
            <Route path="/dashboard/users" component={Users} />
            <Route path="/dashboard/analytics" component={Analytics} />
            <Route path="/dashboard/packages" component={Packages} />
            <Route path="/dashboard/account" component={Accounts} />
            <Route path="/dashboard/knowledge-bank" component={KnowledgeBank} />
          </Switch>
        </Box>
      </Grid>
    </Router>
  );
};

export default Dashboard;
